import React from "react";
import { ResponsiveContainer } from "recharts";

const DEFAULT_WIDTH = 560;

export default function ChartBox({
  height,
  children,
}: {
  height: number;
  children: React.ReactElement;
}): JSX.Element {
  return (
    <ResponsiveContainer
      width="100%"
      height={height}
      minWidth={0}
      minHeight={height}
      initialDimension={{ width: DEFAULT_WIDTH, height }}
    >
      {children}
    </ResponsiveContainer>
  );
}
